import { create } from 'zustand';

export interface AdminProfile {
  id: string;
  name: string;
  username: string;
  email: string;
  role?: string | null;
  screens?: string[];
  hidden_screens?: string[];
  // Resident-app access, for the profile menu's Mobile PIN.
  mobile?: string | null;
  mobile_access?: boolean;
  mobile_app?: boolean;
  mobile_pin_set_at?: string | null;
}

interface AuthState {
  admin: AdminProfile | null;
  signIn: (admin: AdminProfile) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  admin: null,
  signIn: (admin) => set({ admin }),
  signOut: () => set({ admin: null }),
}));
